export default __webpack_public_path__ + "static/media/icone_sessao_expirada.e18ca00d.svg";